export const EDIT_PAYMENT_ITEM_REQUESTED = 'EDIT_PAYMENT_ITEM_REQUESTED';
export const EDIT_PAYMENT_ITEM_SUCCEEDED = 'EDIT_PAYMENT_ITEM_SUCCEEDED';
export const FETCH_PAYMENT_DETAIL_REQUESTED = 'FETCH_PAYMENT_DETAIL_REQUESTED';
export const FETCH_PAYMENT_DETAIL_SUCCEEDED = 'FETCH_PAYMENT_DETAIL_SUCCEEDED';

export const SEND_PAYMENT_TO_ACCOUNTING_REQUESTED = 'SEND_PAYMENT_TO_ACCOUNTING_REQUESTED';

//TODO after we have the payment method entity ready, please move it
export const GET_PAYMENT_METHODS_REQUESTED = 'GET_PAYMENT_METHODS_REQUESTED';
export const GET_PAYMENT_METHODS_SUCCEEDED = 'GET_PAYMENT_METHODS_SUCCEEDED';

export const CANCEL_PAYMENT_REQUESTED = 'CANCEL_PAYMENT_REQUESTED';
export const CANCEL_PAYMENT_SUCCEEDED = 'CANCEL_PAYMENT_SUCCEEDED';
